import { render, staticRenderFns } from "./AboutStory.vue?vue&type=template&id=7859d094&scoped=true&"
import script from "./AboutStory.vue?vue&type=script&lang=js&"
export * from "./AboutStory.vue?vue&type=script&lang=js&"
import style0 from "./AboutStory.vue?vue&type=style&index=0&id=7859d094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7859d094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
